package com.milta.feature.subscription.domain.entity

enum class SubscriptionPlan { Driver, Organisation }
